import { Link } from 'react-router-dom'
import { Button } from '../../components/common'

/**
 * Pagina che spiega il processo di approvazione dei locali
 */
export default function ComeFunziona() {
  return (
    <div className="container mx-auto px-4 py-12">
      {/* Header */}
      <header className="text-center max-w-3xl mx-auto mb-16">
        <h1 className="font-display text-4xl md:text-5xl text-white mb-4">
          Come Funziona il <span className="text-gold">Bollino Approved</span>
        </h1>
        <p className="text-xl text-gray-400">
          Il nostro bollino non si compra e non si chiede:
          si guadagna sul campo, piatto dopo piatto.
        </p>
      </header>

      {/* Il processo */}
      <section className="mb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Step 1 */}
          <div className="relative">
            <div className="bg-night-light rounded-xl p-6 border border-gray-800 h-full">
              <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center mb-4">
                <span className="font-display text-xl text-night">1</span>
              </div>
              <h3 className="font-display text-xl text-white mb-3">Scoperta</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Durante le nostre uscite in fuoristrada esploriamo le zone più remote
                delle Marche. Spesso i locali migliori sono quelli nascosti, lontani
                dalle strade principali.
              </p>
            </div>
            <div className="hidden lg:block absolute top-1/2 -right-4 w-8 text-gold">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>

          {/* Step 2 */}
          <div className="relative">
            <div className="bg-night-light rounded-xl p-6 border border-gray-800 h-full">
              <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center mb-4">
                <span className="font-display text-xl text-night">2</span>
              </div>
              <h3 className="font-display text-xl text-white mb-3">Test sul Campo</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Quando troviamo un posto promettente, ci fermiamo a mangiare.
                Non una volta, ma più volte, in diverse occasioni, per verificare
                la costanza della qualità.
              </p>
            </div>
            <div className="hidden lg:block absolute top-1/2 -right-4 w-8 text-gold">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>

          {/* Step 3 */}
          <div className="relative">
            <div className="bg-night-light rounded-xl p-6 border border-gray-800 h-full">
              <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center mb-4">
                <span className="font-display text-xl text-night">3</span>
              </div>
              <h3 className="font-display text-xl text-white mb-3">Valutazione</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Valutiamo qualità del cibo, genuinità, rapporto qualità-prezzo,
                accoglienza e... sì, anche il parcheggio! I nostri mezzi
                hanno bisogno di spazio.
              </p>
            </div>
            <div className="hidden lg:block absolute top-1/2 -right-4 w-8 text-gold">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>

          {/* Step 4 */}
          <div>
            <div className="bg-gold/10 border border-gold/30 rounded-xl p-6 h-full">
              <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-night" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="font-display text-xl text-gold mb-3">Approvazione</h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                Se il locale passa tutti i nostri "test", entra ufficialmente
                nella guida Conero Garage Approved. Con la sua storia e le
                nostre motivazioni.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Criteri di valutazione */}
      <section className="mb-20">
        <h2 className="font-display text-3xl text-white text-center mb-12">
          I Nostri Criteri
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {/* Criterio 1 */}
          <div className="bg-night-light rounded-xl p-6 border border-gray-800">
            <div className="w-10 h-10 bg-green-900/30 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
              </svg>
            </div>
            <h3 className="font-display text-lg text-white mb-2">Qualità del Cibo</h3>
            <p className="text-gray-400 text-sm">
              Ingredienti freschi, cotture curate, sapori autentici.
              Niente cibi precotti o industriali.
            </p>
          </div>

          {/* Criterio 2 */}
          <div className="bg-night-light rounded-xl p-6 border border-gray-800">
            <div className="w-10 h-10 bg-yellow-900/30 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-5 h-5 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="font-display text-lg text-white mb-2">Rapporto Qualità-Prezzo</h3>
            <p className="text-gray-400 text-sm">
              Non cerchiamo per forza il posto economico, ma quello dove
              ogni euro speso è giustificato.
            </p>
          </div>

          {/* Criterio 3 */}
          <div className="bg-night-light rounded-xl p-6 border border-gray-800">
            <div className="w-10 h-10 bg-blue-900/30 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <h3 className="font-display text-lg text-white mb-2">Autenticità</h3>
            <p className="text-gray-400 text-sm">
              Amiamo i posti genuini, gestiti da famiglie, dove si respira
              la tradizione marchigiana.
            </p>
          </div>

          {/* Criterio 4 */}
          <div className="bg-night-light rounded-xl p-6 border border-gray-800">
            <div className="w-10 h-10 bg-red-900/30 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-5 h-5 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </div>
            <h3 className="font-display text-lg text-white mb-2">Accoglienza</h3>
            <p className="text-gray-400 text-sm">
              L'ospitalità conta. Un sorriso, una chiacchierata, la passione
              di chi gestisce il locale.
            </p>
          </div>

          {/* Criterio 5 */}
          <div className="bg-night-light rounded-xl p-6 border border-gray-800">
            <div className="w-10 h-10 bg-purple-900/30 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-5 h-5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
              </svg>
            </div>
            <h3 className="font-display text-lg text-white mb-2">Costanza</h3>
            <p className="text-gray-400 text-sm">
              Una bella esperienza non basta. Torniamo più volte per
              verificare che la qualità sia costante.
            </p>
          </div>

          {/* Criterio 6 */}
          <div className="bg-night-light rounded-xl p-6 border border-gold/30">
            <div className="w-10 h-10 bg-gold/20 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-5 h-5 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
              </svg>
            </div>
            <h3 className="font-display text-lg text-gold mb-2">Parcheggio 4x4</h3>
            <p className="text-gray-400 text-sm">
              Un plus importante! I nostri mezzi sono grandi e ci piace
              quando c'è spazio per parcheggiarli comodamente.
            </p>
          </div>
        </div>
      </section>

      {/* Segnala un locale */}
      <section className="bg-gold/10 border border-gold/30 rounded-2xl p-8 md:p-12 text-center max-w-3xl mx-auto">
        <h2 className="font-display text-3xl text-white mb-4">
          Conosci un Locale da Segnalare?
        </h2>
        <p className="text-gray-400 mb-8 max-w-xl mx-auto">
          Hai scoperto una trattoria nascosta, un agriturismo sperduto nelle colline
          o un ristorante dove si mangia davvero bene? Faccelo sapere!
          Le segnalazioni della community sono preziose.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/segnala">
            <Button variant="primary">
              Segnala un locale
            </Button>
          </Link>
          <Link to="/locali">
            <Button variant="secondary">
              Esplora i locali
            </Button>
          </Link>
        </div>
      </section>
    </div>
  )
}
